import { Brand } from 'api/categories/_requests';
import { VendorCoupons } from 'api/coupon/_requests';
import axios from 'axios';
import { ProductFilter } from 'components/modules/e-commerce/products-filter/ProductFilterItems';
import { ProductCat } from 'data/e-commerce/products';
import { handleRequest } from 'helpers/api';

const PRODUCTS_URL = `${process.env.REACT_APP_API_URL}/products`;

const productsApi = axios.create({
  baseURL: PRODUCTS_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface VendorProducts {
  _id: string;
  slug: string;
  name: string;
  price: number;
  thumbnail: string;
}

export interface VendorPorductPage {
  data: VendorProducts[];
  total: number;
  page: number;
}

export interface Product {
  _id: string;
  vendorId: string;
  name: string;
  description: string;
  price: number;
  discountedPrice: number;
  images: string[];
  thumbnail: string;
  inStock: boolean;
}

export type VariantType = 'color' | 'size' | 'weight';

export interface AddProduct extends Product {
  industry?: string | null;
  categoryType: string;
  category: string;
  subCategory?: string | null;
  brand: string;
  tags: string[] | undefined;
  variantTypes: VariantType[];
}

export interface ProductVariant {
  _id?: string;
  color: string;
  size: string;
  weight: string;
  price: number;
  discountedPrice: number;
  stockQuantity: number;
  inStock: boolean;
  images: string[];
  isSelected?: boolean;
}

export interface ProductReview {
  review: string;
  rating: number;
  productId: string;
  productVariantId: string | null;
  vendorId: string;
  userId: string;
}
export interface ProductReviewItem {
  _id?: string;
  review?: string;
  rating?: number;
  productId?: string;
  productVariantId?: string | null;
  vendorId?: string;
  userId?: FaqsPoductUser;
  createdAt?: string;
}

export interface ProductReviewDetail {
  review: string;
  rating: number;
  productId: productdata;
  productVariantId: string | null;
  vendorId: string;
  createdAt: Date;
  userId: userdata;
}
export interface ReviewsData {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  reviews: ProductReviewItem[];
}
export interface productdata {
  _id?: string;
  name: string;
}

export interface vendorReviewDetails {
  id?: string;
  review: string;
  rating: number;
  createdAt: string;
  userId: userdata;
}

export interface vendorProductReviewList {
  productReviews: ProductReviewDetail[];
  vendorsReviews: vendorReviewDetails[];
}
export interface userdata {
  _id?: string;
  avatar: string;
  fullName: string;
}

export interface ProductSpc {
  header?: string;
  value?: string;
}

export interface ProductBulkOf {
  quantity?: number;
  price?: number;
}

export interface ProductDetail {
  _id: string;
  vendorId: string;
  slug: string;
  name: string;
  description: string;
  keyfeature: string;
  specification: ProductSpc[];
  bulkOffer: ProductBulkOf[];
  inBox: string[];
  coupons?: string[];
  thumbnail: string;
  productVariantId: string;
  variantTypes: VariantType[];
  variants: ProductVariant[];
  industry?: string;
  categoryType?: string;
  category?: string;
  subCategory?: string;
  brand?: string;
  totalRanking?: number;
  totalRating?: number;
  totalReview?: number;
  tags?: string[] | undefined;
}

export interface HomeProductDetails {
  categoryTypeId?: string;
  categoryTypename?: string;
  brands: Brand[];
  products: ProductCat[];
}

export interface AddFaqs {
  question?: string;
  productId?: string;
  productVariantId?: string | null;
  vendorId?: string;
  userId?: string;
}
export interface EditFaqs {
  _id?: string;
  answer?: string;
}
interface FaqsProduct {
  _id?: string;
  name?: string;
}

interface FaqsPoductUser {
  _id?: string;
  fullName?: string;
  avatar?: string;
}

export interface FaqsItems {
  _id?: string;
  question?: string;
  answer?: string;
  productVariant?: string;
  vendor?: string;
  product?: FaqsProduct;
  user?: FaqsPoductUser;
  createdAt?: string;
}
export interface FaqsData {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  faqs: FaqsItems[];
}

export interface ProductCouponData {
  product: ProductDetail;
  couponst: VendorCoupons;
}

export const getAllProducts = async () => {
  return handleRequest(productsApi.get('/all-products'));
};

export const getAllProductsBySubcategory = async (subCategory: string) => {
  return handleRequest(
    productsApi.get(`/all-products-by-subCategory/${subCategory}`)
  );
};

export const getAllProductReviewByProductId = async (
  id: string,
  page = 1,
  limit = 3
) => {
  return handleRequest(
    productsApi.get<ReviewsData>(
      `/all-productreviews-by-productId/${id}?page=${page}&limit=${limit}`
    )
  );
};

export const getVendorProducts = async () => {
  return handleRequest(productsApi.get<VendorProducts[]>('/vendor'));
};

export const getVendorProductsPage = async (page: number, limit: number) => {
  return handleRequest(
    productsApi.get<VendorPorductPage>(
      `/vendor-products?page=${page}&limit=${limit}`
    )
  );
};

export const getProductByslug = async (slug: string) => {
  return handleRequest(
    productsApi.get<ProductDetail>(`/product-by-slug/${slug}`)
  );
};
export const getProductById = async (productId: string) => {
  return handleRequest(
    productsApi.get<ProductDetail>(`/product-by-id/${productId}`)
  );
};

export const addProduct = async (product: AddProduct) => {
  return handleRequest(productsApi.post('/add-product', product));
};

export const addfaqs = async (faqs: AddFaqs) => {
  return handleRequest(productsApi.post('/add-faqs', faqs));
};
export const editFaq = async (faqs: EditFaqs) => {
  return handleRequest(productsApi.post(`/edit-faqs`, faqs));
};

export const getAllByVendorId = async (vendorId: string) => {
  return handleRequest(
    productsApi.get<FaqsItems[]>(`/getall-faqs-vendor/${vendorId}`)
  );
};

export const getfaqsAnswerbyProduct = async (
  productId: string,
  page = 1,
  limit = 3
) => {
  return handleRequest(
    productsApi.get<FaqsData>(
      `/get-faqs-answer/${productId}?page=${page}&limit=${limit}`
    )
  );
};

export const updateProduct = async (productId: string, product: AddProduct) => {
  return handleRequest(productsApi.put(`/edit-product/${productId}`, product));
};

export const addProductReview = async (product: ProductReview) => {
  return handleRequest(productsApi.post('/add-product-review', product));
};

export const getVendorProductReviewsByVendorId = async (vendorId: string) => {
  return handleRequest(
    productsApi.get<vendorProductReviewList>(
      `/vendor-product-reviews-by-vendorId/${vendorId}`
    )
  );
};

export const getProductReviewByVendorId = async (vendorId: string) => {
  return handleRequest(
    productsApi.get<ProductReviewDetail[]>(
      `/product-reviews-by-vendorId/${vendorId}`
    )
  );
};

export const getAllProductByVendor = async (id: string) => {
  return handleRequest(
    productsApi.get<VendorProducts[]>(`/products-by-vendorId/${id}`)
  );
};

export const getProductsByFiltering = async (
  filters: ProductFilter,
  limit: number,
  page: number
) => {
  return handleRequest(
    productsApi.get('/products-by-filters', {
      params: {
        brands: filters.brands.join(','),
        category: filters.category,
        categoryType: filters.categoryType,
        subCategory: filters.subCategory?.join(',') || null,
        min_price: filters.price.min,
        max_price: filters.price.max,
        search: filters.search,
        limit,
        page
      }
    })
  );
};

export const getProductsByCatTypes = async () => {
  return handleRequest(
    productsApi.get<HomeProductDetails[]>(`/products-by-CatType`)
  );
};

export const getBestSellerProduct = async () => {
  return handleRequest(productsApi.get<ProductCat[]>(`/bestseller-products`));
};

export const getRecentViewProducts = async () => {
  return handleRequest(productsApi.get<ProductCat[]>(`/recent-view-product`));
};
